import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import SearchField from "@/components/feature/SearchField";

const navItems = [
  { label: "首页", path: "/" },
  { label: "剧情介绍", path: `/category/${encodeURIComponent("剧情介绍")}` },
  { label: "演员资料", path: `/category/${encodeURIComponent("演员资料")}` },
  { label: "影视资讯", path: `/category/${encodeURIComponent("影视资讯")}` },
  { label: "关于我们", path: "/about" },
];

export default function SiteHeader() {
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  const isHome = location.pathname === "/";
  const transparent = isHome && !scrolled && !menuOpen;

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 32);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname, location.search]);

  const currentPath = decodeURIComponent(location.pathname);

  const isActive = (path: string) => {
    const decoded = decodeURIComponent(path);
    if (decoded === "/") return currentPath === "/";
    return currentPath === decoded;
  };

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        transparent
          ? "bg-transparent"
          : "border-b border-background-200/70 bg-background-50/95 backdrop-blur-md"
      }`}
    >
      <div className="flex h-16 w-full items-center justify-between gap-6 px-4 md:h-[72px] md:px-6 lg:px-10">
        <Link to="/" className="group flex shrink-0 items-center gap-3">
          <span
            className={`flex h-9 w-9 items-center justify-center rounded-md text-sm font-bold tracking-tight md:h-10 md:w-10 ${
              transparent
                ? "bg-background-50/15 text-background-50 ring-1 ring-background-50/30"
                : "bg-primary-500 text-background-50"
            }`}
          >
            嫂
          </span>
          <span className="flex flex-col leading-none">
            <span
              className={`font-heading text-base font-bold tracking-wide md:text-lg ${
                transparent ? "text-background-50" : "text-foreground-950"
              }`}
            >
              嫂子的诱惑
            </span>
            <span
              className={`mt-1 text-[10px] uppercase tracking-[0.28em] ${
                transparent ? "text-background-50/60" : "text-foreground-400"
              }`}
            >
              The Temptation
            </span>
          </span>
        </Link>

        <nav className="hidden items-center gap-1 lg:flex">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`whitespace-nowrap rounded-full px-3.5 py-2 text-sm transition-colors ${
                isActive(item.path)
                  ? transparent
                    ? "bg-background-50/15 text-background-50"
                    : "bg-primary-50 text-primary-700"
                  : transparent
                    ? "text-background-50/80 hover:text-background-50"
                    : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
              }`}
            >
              {item.label}
            </Link>
          ))}
        </nav>

        <div className="hidden w-[260px] shrink-0 lg:block xl:w-[300px]">
          <SearchField tone={transparent ? "dark" : "light"} compact />
        </div>

        <button
          type="button"
          aria-label={menuOpen ? "关闭菜单" : "打开菜单"}
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((open) => !open)}
          className={`flex h-10 w-10 items-center justify-center rounded-full border transition-colors lg:hidden ${
            transparent
              ? "border-background-50/30 text-background-50"
              : "border-background-200 text-foreground-800"
          }`}
        >
          <i className={`${menuOpen ? "ri-close-line" : "ri-menu-line"} text-xl`} />
        </button>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-6 pt-4 lg:hidden">
          <SearchField />
          <nav className="mt-4 grid gap-1">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`flex items-center justify-between rounded-lg px-3 py-3 text-sm ${
                  isActive(item.path)
                    ? "bg-primary-50 text-primary-700"
                    : "text-foreground-800 hover:bg-background-100"
                }`}
              >
                <span>{item.label}</span>
                <i className="ri-arrow-right-s-line text-base text-foreground-400" />
              </Link>
            ))}
          </nav>
          <p className="mt-4 text-xs leading-relaxed text-foreground-500">
            覆盖剧情介绍、演员资料与影视资讯三类内容，支持关键词搜索。
          </p>
        </div>
      )}
    </header>
  );
}